<div class="crm-compose">
  <div class="compose-type">
    <nb-select size="small" [(selected)]="type">
      <nb-option *ngFor="let t of types" [value]="t">{{ ('activity_type_' + t) | translate }}</nb-option>
    </nb-select>
    <nb-select size="small" [(selected)]="contactId" *ngIf="type === 'cover_letter' && contacts.length" [placeholder]="'crm.none' | translate">
      <nb-option [value]="null">{{ 'crm.none' | translate }}</nb-option>
      <nb-option *ngFor="let c of contacts" [value]="c.id">{{ c.name }}{{ c.company ? ' (' + c.company + ')' : '' }}</nb-option>
    </nb-select>
    <input nbInput fieldSize="small" class="occurred-date"
           [placeholder]="'enterdate' | translate"
           [attr.title]="'crm.occurred_at' | translate"
           [nbDatepicker]="occurredDatePicker"
           [(ngModel)]="occurredDate">
    <nb-datepicker #occurredDatePicker [max]="today"></nb-datepicker>
    <input nbInput fieldSize="small" type="time" class="occurred-time"
           [attr.title]="'crm.occurred_at' | translate"
           [(ngModel)]="occurredTime"
           *ngIf="occurredDate">
  </div>
  <textarea nbInput fullWidth
            class="compose-body"
            rows="4"
            [(ngModel)]="body"
            placeholder="{{ 'logactivityplaceholder' | translate }}"
            [disabled]="saving"
            (keydown)="onKeydown($event)"></textarea>
  <div class="compose-footer">
    <button nbButton size="small" status="primary"
            [disabled]="!body.trim() || saving"
            (click)="submit()">
      {{ 'logactivity' | translate }}
    </button>
  </div>
</div>
